import { IstariClient } from "@istari/istari-client";

import { browserTransferOptions, currentRegistryToken } from "./browser-transfer";
import { invokeWithCurrentToken } from "./client-invocation";
import { identityClientOptions } from "./identity-client-options";
import { resolveRegistryTarget } from "./registry-target";

const getClientSDK = (onToken?: (token: string | undefined) => void) => {
  const target = resolveRegistryTarget();
  const options = {
    registryAuthToken: onToken
      ? async () => {
          const token = await currentRegistryToken();
          onToken(token);
          return token;
        }
      : currentRegistryToken,
    transfer: browserTransferOptions,
    ...identityClientOptions(),
  };
  return new IstariClient(
    target.kind === "gateway"
      ? { digitalApiUrl: target.digitalApiUrl, ...options }
      : { registryUrl: target.registryUrl, ...options },
  );
};

const clientSDK = new Proxy(getClientSDK(), {
  get(target, prop, receiver) {
    const overriddenValue = Reflect.get(target, prop, receiver);
    if (Object.hasOwn(target, prop) && typeof overriddenValue === "function") {
      return overriddenValue.bind(target);
    }

    const client = getClientSDK();
    const value = client[prop as keyof IstariClient];
    if (typeof value === "function") {
      return (...args: unknown[]) => invokeWithCurrentToken(getClientSDK, prop as keyof IstariClient, args);
    }
    return value;
  },
});

export default clientSDK;
